import PageTypeFactory from '../../page/get_page_type';
import GA_EVENTS from './ga_constants';
import { setBehaviourEvent } from './ga_interface';

function clickOnRedeem(obj) {
    const category = GA_EVENTS.voucherCodeLightBox.category;
    const action = GA_EVENTS.voucherCodeLightBox.actions.clickOnRedeem;
    const label = PageTypeFactory.getPageType();
    const value = obj;

    setBehaviourEvent({ category, action, label, value });
}

function close() {
    const category = GA_EVENTS.voucherCodeLightBox.category;
    const action = GA_EVENTS.voucherCodeLightBox.actions.close;
    const label = PageTypeFactory.getPageType();

    setBehaviourEvent({ category, action, label });
}

function open() {
    const category = GA_EVENTS.voucherCodeLightBox.category;
    const action = GA_EVENTS.voucherCodeLightBox.actions.open;
    const label = PageTypeFactory.getPageType();

    setBehaviourEvent({ category, action, label });
}

export {
    clickOnRedeem,
    close,
    open
};
